export enum FooterIconName {
  Chat = 'Chat',
}

export const footerIconAssets: {
  [key in FooterIconName]: string;
} = {
  [FooterIconName.Chat]: require('./ic-chat.svg'),
};
